/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';

import { TextModel } from '@typescript-kit/view';
import { TextDirective } from '../../directive/text.directive';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'span[kitModel]',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextComponent extends TextDirective {

  @Input()
  set kitModel(value: TextModel | string) {
    this.text = value;
  }

  get kitModel(): TextModel | string {
    return this.text;
  }

}
